export default __webpack_public_path__ + "media/images/wp-login@2x.png";